"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M7.5 14.267C6.81903 14.267 6.267 14.819 6.267 15.5V25.5C6.267 26.181 6.81903 26.733 7.5 26.733H17.5C18.181 26.733 18.733 26.181 18.733 25.5V21H20V25.5C20 26.8807 18.8807 28 17.5 28H7.5C6.11929 28 5 26.8807 5 25.5V15.5C5 14.1193 6.11929 13 7.5 13H11V14.267H7.5Z"
}), /*#__PURE__*/_react["default"].createElement("rect", {
  x: "13",
  y: "6",
  width: "13",
  height: "13"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5 6.267H14.5C13.819 6.267 13.267 6.81903 13.267 7.5V17.5C13.267 18.181 13.819 18.733 14.5 18.733H24.5C25.181 18.733 25.733 18.181 25.733 17.5V7.5C25.733 6.81903 25.181 6.267 24.5 6.267ZM14.5 5C13.1193 5 12 6.11929 12 7.5V17.5C12 18.8807 13.1193 20 14.5 20H24.5C25.8807 20 27 18.8807 27 17.5V7.5C27 6.11929 25.8807 5 24.5 5H14.5Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 17L19 8L20.27 8L20.27 17L19 17Z",
  fill: "white"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 12L24 12L24 13.27L15 13.27L15 12Z",
  fill: "white"
})));
module.exports = exports.default;